<template>
  <div>
    <el-backtop></el-backtop>
    <div class="home-header">
      <el-carousel height="880px">
        <el-carousel-item
          v-for="(item, index) in imgList"
          :key="index"
        >
          <img
            style="width: 100%; height: 876px"
            :src="item.photo"
            @click="tiao(index)"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div style="position: absolute;margin-left: 27%;margin-top: -300px;z-index: 1000;">
      <el-button
        style="width: 150px;height: 45px;background-color: Transparent;color: #fff;"
        @click="$router.push('/hyxw1')"
      >更多内容</el-button>
      <el-button
        style="width: 150px;height: 45px;"
        @click="$router.push('/gsjj')"
      >关于我们</el-button>
    </div>
    <div
      class="sycontentRight wow fadeInUp"
      data-wow-duration=".5s"
    >
      <div class="syCenter">
        <div class="gs">关于我们</div>
        <h2>About Us</h2>
        <p>
          北京点奈特医疗科技有限公司（小儿科.net）成立于2021年2月26日，是专注于医疗行业数字化的科技公司，主要业务以虚拟仿真、人工智能、动作捕捉、图像识别等技术相结合的研发型企业。
        </p>
        <div style="display: flex;margin-top: 30px;">
          <el-button
            class="but1"
            @click="$router.push('/gsjj')"
            type="text"
          >
            查看详情
          </el-button>
          <div
            class="but"
            @click="$router.push('/gsjj')"
          >
            <i class="el-icon-right"></i>
          </div>
        </div>
      </div>
      <div>
        <img
          src="@/assets/sy/图层 5.png"
          alt=""
        />
      </div>
    </div>
    <div
      class="xwbk wow fadeInUp"
      data-wow-duration=".5s"
    >
      <el-menu
        router
        :default-active="activeMenu == undefined ? '/hyxw' : activeMenu"
        class="el-menu-vertical-demo"
      >
        <el-menu-item index="/hyxw">
          <span slot="title">新闻资讯 ></span>
        </el-menu-item>
        <el-menu-item index="/zcfg">
          <span slot="title">政策法规 ></span>
        </el-menu-item>
        <el-menu-item index="/xmdt">
          <span slot="title">知识科普 ></span>
        </el-menu-item>
        <!-- <el-menu-item index="/tzgg">
          <span slot="title">通知公告 ></span>
        </el-menu-item> -->
      </el-menu>
      <div style="width: 100%">
        <router-view></router-view>
      </div>
    </div>
    <div
      class="xmzl wow fadeInUp"
      data-wow-duration=".5s"
    >
      <div class="bt">
        <span>项目资料</span>
        <p>PROJECT DATA</p>
      </div>
      <div class="card">
        <div
          class="jtcard"
          v-for="(item, index) in xmData"
          :key="item.id"
          @mouseover="hoverIndex = index"
          @click="clickIndex = index"
          @mouseout="hoverIndex = -1"
        >
          <img
            v-if="index == 0"
            style="width: 70px;height: 70px;"
            src="../assets/sy/矢量智能对象.png"
            alt=""
          />
          <img
            style="width: 70px;height: 70px;"
            v-if="index == 2"
            src="../assets/sy/矢量智能对象-1.png"
            alt=""
          />
          <img
            style="width: 70px;height: 70px;"
            v-if="index == 3"
            src="../assets/sy/矢量智能对象-2.png"
            alt=""
          />
          <img
            style="width: 70px;height: 70px;"
            v-if="index == 1"
            src="../assets/sy/矢量智能对象-3.png"
            alt=""
          />
          <h3>{{ item.name }}</h3>
          <p>{{ item.digest }}</p>
          <p>{{ item.digest1 }}</p>
          <p>{{ item.digest2 }}</p>
          <p>{{ item.digest3 }}</p>
          <!-- <el-button
            style="margin-top: 30px"
            type="text"
            v-show="index != hoverIndex"
          >查看详情</el-button>
          <el-button
            type="primary"
            style="margin-top: 30px"
            v-show="index == hoverIndex"
            @click="chageXQ(item)"
          >查看详情</el-button> -->
        </div>
      </div>
    </div>
    <div class="gswz">
      <div class="bt">
        <span>公司位置</span>
        <p>COMPANY LOCATION</p>
      </div>
      <div class="dt">
        <el-amap
          vid="amapDemo"
          :center="center"
          :zoom="zoom"
          class="amap-demo"
          :events="events"
        >
          <el-amap-marker
            :position="marker.position"
            :events="marker.events"
            :visible="marker.visible"
            :draggable="marker.draggable"
          ></el-amap-marker>
        </el-amap>
      </div>
    </div>
  </div>
</template>

<script>
import WOW from "wowjs";
import { selectcoll, selectcol, photo } from "@/api/patient.js";
import videoPlayer from "../components/vueVideoPlayer.vue";
import HYXW from "./dataModel/hyxw.vue";
export default {
  components: {
    videoPlayer,
    HYXW,
    // SwiperSlide,
  },
  name: "Home",
  data() {
    return {
      httpsURL: "http://139.196.240.19:80/",
      imgList: [
        {
          id: 1,
          photo: require("../assets/sy/sybj.png"),
        },
      ],
      comCurrentIndex: 0,
      zoom: 15,
      center: [116.598821, 39.892327],
      searchOption: {
        city: "全国",
        citylimit: true,
      },
      marker: {
        position: [116.598821, 39.892327],
      },
      address: "",
      events: {
        click(e) {
          let { lng, lat } = e.lnglat;
          self.lng = lng;
          self.lat = lat;
          self.marker.position = [lng, lat];
          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all",
          });
          geocoder.getAddress([lng, lat], function (status, result) {
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                self.address = result.regeocode.formattedAddress;
                self.$nextTick();
              }
            }
          });
        },
      },

      page: 1,
      rows: 4,
      xmData: [
        {
          ctime: "2020-08-21 15:39:31",
          digest:
            "聚焦早期识别难的痛点，通过图像识别、动作捕捉技术结合 AI 大模型分析，为儿童群体提供便捷、高效的早期风险筛查工具，助力疾病的早发现、早预警。",
          // digest1: "2.  医养健康咨询+共享医疗咨询问诊平台。",
          // digest2: "3.  基层医生业务指导+培训。",
          // digest3:"4.  建立居民健康档案，慢病管理+健康数据收	集，由医联体转向健联体。",
          id: 6,
          link: "",
          name: "院前智能筛查阶段",
          path: "",
          status: "0",
        },
        {
          ctime: "2020-08-21 15:39:31",
          digest:
            "针对诊疗方案个性化不足的问题，基于 AI 大模型整合的临床数据与诊疗指南，为医护人员提供精准的病情分析、方案推荐等辅助决策支持，提升院内诊疗的规范化与个体化水平。",
          // digest1: "2. 术前术后专业病种的护理。",
          // digest2: "3.  普惠养老、生活照料医护预约平台。",
          // digest3:"",
          id: 7,
          link: "",
          name: "院中辅助治疗阶段",
          path: "",
          status: "0",
        },
        {
          ctime: "2020-08-21 15:39:31",
          digest:
            "破解康复管理碎片化、科普同质化痛点，搭建家长端监测指导渠道，依托 AI 实现康复数据实时采集评估、生成个性化方案，保障院后康复连续科学。",
          // digest1: "2. 药食同源食疗养生健康绿色食品跟踪服务平台。",
          // digest2: "3. 居家养老+旅游养生结合。",
          // digest3:"",
          id: 8,
          link: "",
          name: "院后康复随访阶段",
          path: "",
          status: "0",
        },
      ],
      datatotal: 0,
      hoverIndex: -1, //表示当前hover的是第几个li 初始为 -1 或 null 不能为0 0表示第一个li
      clickIndex: -1, //表示当前点击的是第几个li 初始为 -1 或 null 不能为0 0表示第一个li
      hzData: [],
    };
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
  mounted() {
    // this.getphoto();
    this.getSelectcol();
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: false,
        live: true,
      });
      wow.init();
    }, 200);
  },
  methods: {
    tiao(e) {
      if (e !== 0) {
        this.$router.push("/products");
      }
    },
    getphoto() {
      photo().then((res) => {
        this.imgList = res;
      });
    },
    // course() {
    //   let data = new FormData();
    //   data.append("id", "81");
    //   course(data).then((res) => {
    //     console.log("course", res);
    //   });
    // },
    // 合作机构向左
    toLeft() {
      if (this.comCurrentIndex == 0) {
        this.comCurrentIndex = 0;
      } else {
        this.comCurrentIndex--;
      }
    },
    // 合作机构向右
    toRight() {
      // if (this.comCurrentIndex == Math.ceil(this.hzData.length / 7) - 1) {
      //   this.comCurrentIndex = Math.ceil(this.hzData.length / 7) - 1;
      // } else {
      this.comCurrentIndex++;
      // }
    },
    //查看详情
    chageXQ(item) {
      var url = "http://" + item.link;
      window.open(url);
    },
    //获取合作企业
    async getSelectcol() {
      let data = new FormData();
      data.append("page", this.page);
      data.append("rows", 100);
      data.append("xueyuan", "倒");
      selectcol(data).then((res) => {
        this.hzData = res.rows;
      });
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.home-header {
  width: 100%;
  cursor: pointer;
}

.compution {
  width: 100%;
  // background-color: #fafafa;
  text-align: center;
  padding-bottom: 60px;
  position: relative;

  h2 {
    margin-top: 80px;
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }

  h1 {
    margin-top: -10px;
    margin-bottom: 50px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .allCom {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    height: 152px;
    position: relative;

    .comContent {
      width: 30008px;
      display: flex;
      height: 150px;
      position: absolute;
      top: 0;
      left: 0;
      transition: 0.5s linear all;

      .comWrapper {
        width: 150px;
        height: 150px;
        margin-right: 10px;
        margin-left: 10px;
        background-color: #fff;
        border: #aaa solid 1px;
        display: flex;
        justify-content: center;
        align-items: center;

        a {
          img {
            width: 100px;
            height: 100px;
            line-height: 150px;
            text-align: center;
            transition: 0.5s all linear;

            &:hover {
              transform: scale(1.1);
            }
          }
        }
      }
    }
  }

  .comLeft {
    position: absolute;
    left: 10vw;
    top: 180px;
    font-size: 50px;
    cursor: pointer;
  }

  .comRight {
    position: absolute;
    right: 10vw;
    top: 180px;
    font-size: 50px;
    cursor: pointer;
  }

  .getMore {
    margin: 40px auto;
    font-size: 16px;
    color: #000;
    cursor: pointer;
    border: 1px solid #aaa;
    width: 110px;
    height: 30px;
    line-height: 30px;
    border-radius: 2px;

    &:hover {
      background-color: #ff7233;
      color: #fff;
      border-color: #fff;
    }
  }
}

.gswz {
  width: 100%;
  margin-bottom: 50px;

  .dt {
    width: 1200px;
    height: 604px;
    margin: auto;
    // padding: 0 20px;
    border: 1px solid #999999;
  }

  .bt {
    padding-top: 70px;
    text-align: center;

    span {
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }

    p {
      margin-top: 10px;
      margin-bottom: 50px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
  }
}

.xmzl {
  width: 100%;
  height: 750px;
  background: #f8f8fa;

  .card {
    display: flex;
    justify-content: center;
    align-items: center;

    .jtcard {
      width: 296px;
      height: 489px;
      border-radius: 10px;
      margin: 10px;
      box-shadow: 0px 0px 10px 0px rgba(170, 175, 175, 0.21);
      text-align: center;

      img {
        margin-top: 60px;
      }

      h3 {
        margin-top: 50px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #171717;
        margin-bottom: 30px;
      }

      p {
        margin-left: 1rem;
        width: 270px;
        margin-bottom: -5px;
        font-weight: 400;
        line-height: 30px;
        color: #333333;
        font-size: 15px;
        font-family: Microsoft YaHei;
        text-align: left;
      }
    }

    .jtcard:hover {
      width: 296px;
      height: 489px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(170, 175, 175, 0.21);
      border-radius: 10px;
    }
  }

  .bt {
    padding-top: 70px;
    text-align: center;

    span {
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }

    p {
      margin-top: 10px;
      margin-bottom: 50px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
  }
}

.xwbk {
  display: flex;
  width: 1200px;
  margin: 5rem auto;

  .el-menu {
    width: 240px;

    .el-menu-item {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(155, 155, 155, 0.21);
      border-bottom: 1px solid #eeeeee;
      text-align: center;
    }
  }
}

.sycontentRight {
  display: flex;
  margin: auto;
  width: 1200px;
  height: 395px;
  margin-top: 60px;
  background: #ffffff;
  box-shadow: 0px 5px 33px 2px rgba(128, 128, 128, 0.32);

  .syCenter {
    width: 1200px;
    margin-top: 3rem;

    .gs {
      margin-left: 71px;
      // padding-top: 30px;
      width: 320px;
      height: 26px;
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #296cbf;
      line-height: 51px;
    }

    h2 {
      margin-left: 71px;
      width: 100px;
      height: 14px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #296cbf;
      line-height: 30px;
      margin-bottom: 2rem;
    }

    p {
      margin-left: 71px;
      width: 684px;
      height: 79px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #8d8d8d;
      line-height: 30px;
    }

    .but {
      font-size: 20px;
      margin-left: 600px;
      margin-top: 50px;
      color: #296cbf;
      cursor: pointer;
    }
    .but1 {
      margin-left: 71px;
      margin-top: 50px;
      color: #296cbf;
    }
  }
}
</style>
